import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react'
import { cn } from '../lib/cn.ts'

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string
  action?: ReactNode
}

export const Field = forwardRef<HTMLInputElement, FieldProps>(function Field(
  { label, action, className, ...props },
  ref,
) {
  return (
    <label className="flex flex-col gap-1.5">
      <span className="flex items-baseline justify-between gap-2.5">
        <span className="text-[13px] font-medium text-ink-soft">{label}</span>
        {action}
      </span>
      <input
        ref={ref}
        className={cn(
          'rounded-control border border-line-strong bg-surface-soft px-3.5 py-2.5 text-[15px] text-ink outline-none',
          'transition-[border-color,box-shadow] placeholder:text-ink-muted',
          'focus:border-brand focus:shadow-[0_0_0_3px_var(--color-brand-ring)] focus-visible:outline-none',
          className,
        )}
        {...props}
      />
    </label>
  )
})
